import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

export function getValueChanges<T>(form: AbstractControl): Observable<T> {
    return form.valueChanges.pipe(
        startWith(getValue(form)),
        map(() => getValue(form))
    );
}

function getValue<T>(control: AbstractControl): T {
    if (!hasControls(control)) {
        return control.value as T;
    }

    const controls = (control as FormGroup | FormArray).controls;

    if (Array.isArray(controls)) {
        return controls.map(getValue) as unknown as T;
    }

    const result: Partial<Record<string, unknown>> = {};
    for (const [key, child] of Object.entries(controls)) {
        result[key] = getValue(child);
    }
    return result as T;
}

function hasControls(control: AbstractControl): boolean {
    return 'controls' in control;
}
